<template>
  <div class="webhook">
    <h1 class="text-left">Edit Webhook</h1>

    <ValidationObserver ref="webhookForm" tag="form" v-on:submit.prevent="saveWebhook()">
      <div>
        <ul>
          <li>
            <label for="payload-URL">Payload URL <variables v-bind:variables="variablesCopy" v-bind:obj="webhook" v-bind:propertyName="'payloadURL'" v-bind:inputText="contentInput" v-bind:popupPosition="'bottom-right'"></variables></label>
            <div>
              <ValidationProvider rules="required|min:20" v-slot="{ errors }">
                <input type="text" v-model="webhook.payloadURL" v-on:keydown="changed = true" v-on:focusout="changed = true" id="payload-URL" ref="payloadURL" placeholder="Payload URL" class="short-question">
                <span class="form__error" v-if="errors">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </li>
          <li v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : updating, 'infobar-error' : error}">
            {{infoMessage}}
          </li>

          <li v-show="!updating">
            <div class="col-6 offset-3">
              <div class="row email-editor-buttons">
                <div class="col-6">
                  <button class="btn btn-secondary" v-on:click.prevent="cancel">Cancel</button>
                </div>
                <div class="col-6">
                  <button class="btn btn-primary" v-bind:aria-disabled="!changed" v-bind:class="{'btn-disabled' : !changed}">Save</button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </ValidationObserver>

    <confirm-dialog v-bind:continuePrimaryText="'Save'"
                    v-bind:message="confirmLoseChangesMessage"
                    v-bind:callbackPrimaryName="'save-webhook'"
                    v-bind:callbackPrimaryReference="'save'"
                    v-if="showConfirmLoseChangesDialog"/>
  </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider, /*extend*/ } from 'vee-validate'

    import { store} from '../store.js'
    import Variables from "../components/establishments/Variables";
    import ConfirmDialog from '../components/ConfirmDialog.vue'

    import { variablesMixin } from '../mixins/VariablesMixin'

    export default {
        name: "EditWebhook",
        components: {
            ValidationObserver, ValidationProvider, Variables, ConfirmDialog
        },
        mixins: [ variablesMixin ],
        data() {
            return {
                reference: null,
                contentInput: null,
                webhook: {
                    payloadURL: "", contentType: "application-json"
                },
                changed: false,
                cancelling: false,
                updating: false,
                error: false,
                infoMessage: "",
                confirmLoseChangesMessage: "You have un-saved changes to this webhook. Would you like to save your work before leaving the page?",
                showConfirmLoseChangesDialog: false,
                navigatingToRoute: "",
                parentAutomation: null
            }
        },
        computed: {},
        methods: {
            cancel: function() {
                console.log("cancel");
                this.cancelling = true;
                const route = { name: 'Automations' };
                if (this.parentAutomation) {
                    route.query = { automation: this.parentAutomation };
                }
                this.$router.push(route);
            },
            saveWebhook: async function() {
                console.log("Saving webhook");
                try {
                    const success = await this.$refs.webhookForm.validate();
                    console.log("Validated:" + success);
                    if (!success) {
                        return;
                    }
                    this.updating = true;
                    this.error = false;
                    this.infoMessage = "Saving webhook";

                    const body = {
                        payloadURL: this.webhook.payloadURL,
                        contentType: this.webhook.contentType,
                    };

                    const response = await this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/webhooks/' + this.reference, body);
                    console.log("Webhook updated. Response: " + response);
                    this.infoMessage = "Webhook saved";
                    this.changed = false;
                    setTimeout(() => {
                        this.updating = false;
                    }, 2000);
                } catch (error) {
                    this.updating = false;
                    this.error = true;
                    if (error.response) {
                        this.infoMessage = error.response.data.message;
                    } else {
                        this.infoMessage = "Sorry, we can't seem to reach our servers! Please try again";
                    }
                }
            }
        },
        mounted: async function () {
            this.contentInput = this.$refs.payloadURL;

            this.reference = this.$route.params.reference;

            await this.fetchVariables();

            if (this.$route.query && this.$route.query.parentAutomation) {
                this.parentAutomation = this.$route.query.parentAutomation;
            }

            this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/webhooks/' + this.reference).then(response => {
                this.webhook = response.data;
                this.changed = false;
            }).catch(error => {
                console.log(error)
            });

            this.saveBeforeLeavingFn = async (action) => {
                if (action === "save") {
                    await this.saveWebhook();
                    this.$router.push({name: this.navigatingToRoute.name });
                    this.showConfirmLoseChangesDialog = false;
                } else {
                    this.showConfirmLoseChangesDialog = false;
                }
            };
            this.$root.$on('save-webhook', this.saveBeforeLeavingFn);
        },
        beforeDestroy() {
            this.$root.$off('save-webhook', this.saveBeforeLeavingFn);
        },
        beforeRouteLeave (to, from, next) {
            if (this.changed && !this.cancelling) {
                this.navigatingToRoute = to;
                this.showConfirmLoseChangesDialog = true;
            } else {
                next();
            }
        }
    }
</script>

<style lang="scss" scoped>
  @import "../styles/layout/forms.scss";
  @import "../styles/components/question_answer";
  @import "../styles/pages/edit_webhook";
</style>